import { render, staticRenderFns } from "./DetailTicketEvent.vue?vue&type=template&id=757b4467&"
import script from "./DetailTicketEvent.vue?vue&type=script&lang=js&"
export * from "./DetailTicketEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports